<template>
    <div class="routers">
        <Head-view :showStyle="3"></Head-view>
        <div class="main">
            <div class="breadcrumb">路线管理</div>
            <div class="nav">
                <div class="searchLeft">
                    <div class="fontName">路线名称</div>
                    <div class="searchInp">
                        <el-input
                            v-model="searchVal"
                            prefix-icon="el-icon-search"
                            placeholder="请输入"
                        ></el-input>
                    </div>
                    <div class="departName">点位</div>
                    <div class="searchInp">
                        <el-select
                            v-model="soptVal"
                            clearable
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in soptArr"
                                :key="item.placeId"
                                :label="item.name"
                                :value="item.placeId"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="searchBtn" @click="searchBtn()">搜索</div>
                </div>
                <div class="institutionAddBtn" @click="addrouters()">
                    新建路线
                </div>
            </div>

            <div class="showTba">
                <div class="bodyTable">
                    <el-table
                        :data="tableData"
                        style="width: 100%; max-height: 489px"
                        height="489px"
                        stripe
                        :header-cell-style="{ textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center' }"
                        v-loading="loading"
                    >
                        <el-table-column
                            prop="name"
                            label="路线名称"
                            width="300"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="province"
                            label="路线图片"
                            width="300"
                        >
                            <template slot-scope="scope">
                                <div class="pictureImg">
                                    <img v-if="scope.row.picture" :src="scope.row.picture" alt="" />
                                    <img v-if="!scope.row.picture" src="../../assets/routerDefaultImg.png" alt="" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="placeCountFont"
                            label="点位数"
                            width="300"
                        >
                        </el-table-column>
                        <el-table-column label="点位" width="400">
                            <template slot-scope="scope">
                                <div class="places">
                                    {{ scope.row.places }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="300">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleEide(scope.$index, scope.row)"
                                    type="text"
                                    size="small"
                                    class="colorBulr"
                                    >编辑</el-button
                                >&nbsp;&nbsp;
                                <el-button
                                    type="text"
                                    size="small"
                                    class="colorRed"
                                    @click="removeInst(scope.$index, scope.row)"
                                    >删除</el-button
                                >&nbsp;&nbsp;
                                <el-button
                                    class="colorBulr"
                                    type="text"
                                    size="small"
                                    @click="handleDataMsg(scope.$index, scope.row)"
                                    >详情</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageObj.currentPage"
                        :page-sizes="pageObj.pageSizeArr"
                        :page-size="pageObj.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageObj.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
export default {
    name: "routers",
    data() {
        return {
            searchVal: "",

            soptVal: "",
            soptArr: [],

            tableData: [],

            insId: "",

            pageObj: {
                currentPage: 1,
                pageSizeArr: [10, 40, 100, 400],
                pageSize: 10,
                total: 0,
            },

            loading: false,

            newPassword: "",
            newPasswords: "",
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"))
        this.routersInfo();
        this.getAllPlace()
    },

    methods: {
        routersInfo(searchFlag = false) {
            this.loading = true
            if (this.searchVal != '' && searchFlag) {
                this.pageObj.currentPage = 1
            }
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                placeId: this.soptVal == "" ? -1 : this.soptVal,
                keyword: this.searchVal,
                page: this.pageObj.currentPage,
                limit: this.pageObj.pageSize,
            };
            this.request
                .post(this.baseUrl + "route/getRouteList", data)
                .then((res) => {
                    if (res.code == 0 && res.data.totalCount >= 0) {
                        let dataArr = []
                        res.data.list.forEach((item, key) => {
                            dataArr.push(item);
                            dataArr[key]["placeCountFont"] =
                                item.placeCount + "个";
                        });
                        this.tableData = dataArr
                        this.pageObj.total = res.data.totalCount;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                    this.loading = false
                })
                .catch((err) => {
                    this.loading = false
                    this.$message({
                        type: "warning",
                        message: "获取点位列表失败",
                    });
                });
        },

        getAllPlace() {
            //获取点位管理
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                keyword: "",
            };
            this.request
                .post(this.baseUrl + "place/getAllPlaceList", data)
                .then((res) => {
                    if (res.code == 0) {
                        let dataArr = [];
                        res.data.forEach((item, key) => {
                            dataArr.push(item);
                            dataArr[key]["flag"] = false;
                        });
                        this.soptArr = dataArr;
                    } else {
                        this.$message({
                            type: "waring",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "出错了，获取点位失败",
                    });
                });
        },

        searchBtn() {
            this.routersInfo(true)
        },

        addrouters() {
            this.$router.push("/routers/routersAdd");
        },
        handleSizeChange(val) {
            this.pageObj.pageSize = val;
            this.routersInfo();
        },
        handleCurrentChange(val) {
            this.pageObj.currentPage = val;
            this.routersInfo();
        },
        handleEide(index, row) {    //
            this.$router.push({
                path: "/routers/routersAdd",
                query: {
                    id: row.routeId
                },
            });
        },

        handleDataMsg(index, row) {
            this.$router.push({
                path: "/routers/routersAdd",
                query: {
                    id: row.routeId,
                    flag: true
                },
            });
        },

        removeInst(index, row) {
            this.$confirm("是否删除本路线相关的任务？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = {
                        token: this.getCookie(),
                        routeId: row.routeId,
                    };
                    this.request
                        .post(this.baseUrl + "route/deleteRoute", data)
                        .then((res) => {
                            if (res.code == 0 && res.data.result) {
                                this.routersInfo()
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "删除失败",
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message({
                                type: "error",
                                message: "出错了，删除失败",
                            });
                        });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="less" scoped>
.routers {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            margin-left: 7px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .nav {
            margin-top: 24px;
            margin-left: 7px;
            height: 68px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            .searchLeft {
                float: left;
                margin: 12px 0 0 20px;
                display: flex;
                flex-direction: row;
                height: 40px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                .fontName {
                    width: 72px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    line-height: 40px;
                }
                .searchInp {
                    width: 211px;
                }
                .departName {
                    width: 64px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    text-align: center;
                    line-height: 40px;
                }
                .searchBtn {
                    margin-left: 20px;
                    width: 68px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: rgba(4, 134, 254, 1);
                    border-radius: 4px;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                }
            }

            .institutionAddBtn {
                margin: 14px 17px 0 0;
                float: right;
                width: 95px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background: rgba(4, 134, 254, 1);
                border-radius: 4px;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }
        }
        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            padding: 16px 17px 0 31px;
            height: 618px;
            background: #fff;
            .bodyTable {
                width: 100%;
                height: 500px;
                overflow: hidden;
                overflow-y: auto;
                .pictureImg {
                    margin: 0 auto;
                    width: 78px;
                    height: 78px;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }

                .places {
                    font-size: 14px;
                    max-height: 103px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .pageination {
                margin-top: 69px;
                text-align: right;
            }
        }

        .colorRed {
            color: rgba(255, 87, 51, 1);
        }

        .colorBulr {
            color: rgba(25, 137, 250, 1);
        }
    }
}
</style>